import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
import { Type } from 'class-transformer';

export class VendorAccountHistoryResultDto {
    id: number;
    action: string;
    beginValue: string;
    endValue: string;

    @Type(() => UserNameDisplayResultDto)
    user: UserNameDisplayResultDto;

    @Type(() => Date)
    actionedOn: Date; // NOTE: Is in UTC time zone. Will need to convert to user preference time zone and display date and time
}
